import React, { useState, useEffect } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

// import JS files
import AdminReportOrderCardLeftPartTemplate from "../../shares/AdminReportOrderCardLeftPartTemplate";
import AdminProviderOrderCard from "../../shares/AdminProviderOrderCard";
import TableIconModal from "../../../shares/TableIconModal";
import { defaultRingSize } from "../../../../constants/constants";

const OrderDetails = (props) => {
  const [openModal, setOpenModal] = useState(false);
  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));

  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<RemoveRedEyeIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <div>
          <div className="overflow-scroll max-h-96">
            {
              <AdminProviderOrderCard item={props.selectedRow} showColorGender>
                <AdminReportOrderCardLeftPartTemplate
                  nums={nums}
                  data_item={props.data}
                  cantEdit={true}
                />
              </AdminProviderOrderCard>
            }
          </div>
        </div>
      </TableIconModal>
    </>
  );
};

export default OrderDetails;
